module.exports = __webpack_public_path__ + "static/media/loopia.1f69ceab.svg";